import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Box, Typography } from "@mui/material";

import { ReactComponent as CircularProgress } from "assets/img/ONYX_X_logo.svg";
import styles from "assets/jss/default/components/loadingHOCStyle.js";

const useStyles = makeStyles(styles as any);

export interface ProgressIndicatorContainerProps {
  loading: boolean;
  error?: boolean;
  errorMessage?: string;
}

const ProgressIndicatorContainerComp = React.forwardRef<
  any,
  React.PropsWithChildren<ProgressIndicatorContainerProps>
>(function ProgressIndicatorContainerComp(
  {
    loading,
    error = false,
    errorMessage = "Failed to load content...",
    children
  },
  ref
): JSX.Element {
  const loadingClasses = useStyles();

  if (loading) {
    return (
      <Box
        sx={{ display: "contents !important" }}
        aria-live="polite"
        aria-busy="true"
        data-testid="loading-indicator"
      >
        <CircularProgress ref={ref} className={loadingClasses.spinner} />
      </Box>
    );
  }

  if (error) {
    console.error(error);
    return (
      <Typography ref={ref} align="center">
        {errorMessage}
      </Typography>
    );
  }

  return <>{children}</>;
});

const ProgressIndicatorContainer = React.memo(ProgressIndicatorContainerComp);

export default ProgressIndicatorContainer;
